export const groupByList  = [{label: "Brands", value: "brandName"}, {label: "Sizes", value: "sizeName"}, {label: "Categories", value: "categoryShortName"}]
export const orderByList  = [{label: "Total #", value: "count"}, {label: "Total $", value: "priceSoldSum"}]

export const DEFAULT_GROUP_BY = 'brandName'
export const DEFAULT_ORDER_BY = 'count'

export const DATA_MAX_LENGTH = 10